import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { compose } from 'react-recompose';

import { SimpleLoadingComponent } from '../../utils/apollo';
import CollegeEventsFiltersPage from './filters-page';
import replaceCollegeEventFilterMutation from './graphql/replaceCollegeEventFilterMutation';
import deleteCollegeEventFilterMutation from './graphql/deleteCollegeEventFilterMutation';
import { withEnabledFeatures } from '../../utils/features';

const query = gql`
  query collegeEventsFilters {
    viewer {
      id
      eventFilters {
        id
        name
        distanceUnit
        distanceValue
        gradeLevels
        ethnicities
        genders
        postalCode
        gpaScores
        visible
        version
        publishedCollegeEventCount
        filterMatches
      }
    }
  }
`;

const graphqlData = graphql(query, { options: { fetchPolicy: 'cache-and-network' } });

const renameCollegeEventFilter = graphql(replaceCollegeEventFilterMutation, {
  name: 'renameCollegeEventFilter',
});

const deleteCollegeEventFilter = graphql(deleteCollegeEventFilterMutation, {
  name: 'deleteCollegeEventFilter',
});

export default SimpleLoadingComponent(
  compose(
    withEnabledFeatures,
    graphqlData,
  ),
  renameCollegeEventFilter,
  deleteCollegeEventFilter,
)(CollegeEventsFiltersPage);
